import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { ToolTipHover } from "./ToolTipHover";

const EditCapsuleStrength = ({
  form,
  isPharmacy,
  editedCapsStrength,
  handleEditCapsStrength,
  handleCapsuleStrEditChange,
  DropdownIndicator,
  isFormApproved,
  mgFor,
  handleCapsuleStrEditInvalid,
  capsule_changes_tracker,
}) => {
  const [currentCapsStrength, setCurrentCapsStrength] = useState([]);
  const notEditable = useMemo(() => {
    return currentCapsStrength.every((caps) => caps.exists);
  }, [currentCapsStrength]);
  const mg = useMemo(() => {
    if (mgFor?.includes(".")) {
      return mgFor.split(".").join("_");
    }
    return mgFor;
  }, [mgFor]);
  const capsuleStrengthFullList = useMemo(
    () => [
      { label: "2.5mg", value: 2.5 },
      { label: "5mg", value: 5 },
      { label: "7.5mg", value: 7.5 },
      { label: "10mg", value: 10 },
      { label: "15mg", value: 15 },
      { label: "20mg", value: 20 },
      { label: "25mg", value: 25 },
    ],
    []
  );

  useEffect(() => {
    const {
      capsule_cycle_2_5,
      capsule_cycle_5,
      capsule_cycle_7_5,
      capsule_cycle_10,
      capsule_cycle_15,
      capsule_cycle_20,
      capsule_cycle_25,
      capsule_cycle_other_2_5,
      capsule_cycle_other_5,
      capsule_cycle_other_7_5,
      capsule_cycle_other_10,
      capsule_cycle_other_15,
      capsule_cycle_other_20,
      capsule_cycle_other_25,
    } = form;

    const has2_5mg = !!capsule_cycle_2_5 || !!capsule_cycle_other_2_5;
    const has5mg = !!capsule_cycle_5 || !!capsule_cycle_other_5;
    const has7_5mg = !!capsule_cycle_7_5 || !!capsule_cycle_other_7_5;
    const has10mg = !!capsule_cycle_10 || !!capsule_cycle_other_10;
    const has15mg = !!capsule_cycle_15 || !!capsule_cycle_other_15;
    const has20mg = !!capsule_cycle_20 || !!capsule_cycle_other_20;
    const has25mg = !!capsule_cycle_25 || !!capsule_cycle_other_25;

    setCurrentCapsStrength([
      { label: "2.5mg", exists: has2_5mg },
      { label: "5mg", exists: has5mg },
      { label: "7.5mg", exists: has7_5mg },
      { label: "10mg", exists: has10mg },
      { label: "15mg", exists: has15mg },
      { label: "20mg", exists: has20mg },
      { label: "25mg", exists: has25mg },
    ]);
  }, [form]);

  const getCustomStrengthOptions = () => {
    let strengthArray = capsuleStrengthFullList.filter((capsStrength) => {
      let hasOptionAvailable = currentCapsStrength.find(
        (caps) => caps?.label === capsStrength.label
      );
      return (
        !hasOptionAvailable?.exists ||
        hasOptionAvailable?.label === mg.replace("_", ".")
      );
    });
    return strengthArray;
  };

  const are_capsules_tracker_changed = (capsule_changes_tracker || []).find(
    (element) => {
      return element.capsule_strength_view_new === mg.split("mg")[0];
    }
  );

  const is_form_ready_form_approve =
    isPharmacy &&
    (form?.status === "Submitted" ||
      form?.status === "Overdue" ||
      form?.status === "Expiring");

  return (
    <div className="col display-flex-tooltip">
      {!editedCapsStrength[mg] && (
        <>
          <span
            className={
              "font-size-16 tool-tip-wrapper-capsule-strength " +
              (mgFor === "Incomplete" ? "red-label " : "") +
              (!!are_capsules_tracker_changed?.capsule_strength_view_new &&
              !is_form_ready_form_approve
                ? "green-haze"
                : "")
            }
          >
            {mgFor}
          </span>
          {!!are_capsules_tracker_changed?.capsule_strength_view_new &&
            !is_form_ready_form_approve && (
              <ToolTipHover
                capsule_changes_tracker={are_capsules_tracker_changed}
                changedBy={form.approved_or_rejected_by}
                changedOn={form.accepted_date}
                typeOfField="capsule_strength"
              />
            )}
        </>
      )}
      {(form?.status === "Submitted" ||
        form?.status === "Overdue" ||
        form?.status === "Expiring") &&
        isPharmacy &&
        !editedCapsStrength[mg] && (
          <React.Fragment>
            {isFormApproved === null && !notEditable && (
              <span
                className="edit-option"
                onClick={() => handleEditCapsStrength(mg)}
              >
                EDIT
              </span>
            )}
          </React.Fragment>
        )}
      {editedCapsStrength[mg] && (
        <Select
          menuShouldScrollIntoView={false}
          classNamePrefix="margin-custom-select custom-select"
          className="selectWidth"
          components={{
            DropdownIndicator: DropdownIndicator,
            IndicatorSeparator: () => null,
          }}
          onChange={(e) => {
            mg === "Incomplete"
              ? handleCapsuleStrEditInvalid(mg, e)
              : handleCapsuleStrEditChange(mg.slice(0, mg.length - 2), e);
          }}
          value={capsuleStrengthFullList.find(
            (capsStrength) => capsStrength?.label === mg
          )}
          options={getCustomStrengthOptions()}
          placeholder="Select"
        />
      )}
    </div>
  );
};

EditCapsuleStrength.propTypes = {
  form: PropTypes.object,
  isPharmacy: PropTypes.bool,
  editedCapsStrength: PropTypes.object,
  handleEditCapsStrength: PropTypes.func,
  handleCapsuleStrEditChange: PropTypes.func,
  DropdownIndicator: PropTypes.func,
  isFormApproved: PropTypes.bool,
  mgFor: PropTypes.string,
};

export default EditCapsuleStrength;
